<template>
  <div class="main-conent main-conent-maxheight">
    <div class="screen-frame">
      <iframe
        :src="src"
        width="100%"
        style="position: relative;top: 0px;height: 100%;"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: Number,
    width: Number
  },
  computed: {
    src() {
      return 'http://whzl.scwhnk.com/screen/13_19201080_zsk_xinchaxiang/bch.html'
    }
  }
}
</script>

<style lang="css" scoped>
.screen-frame {
  overflow: hidden;
  height: 100%;
}
</style>
